import { useState } from 'react';
import { logoFallbackPath, logoPath } from '../../config/env';
import { t } from '../../i18n';
import './Logo.css';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'auth';
  showWordmark?: boolean;
  src?: string;
}

export function Logo({
  size = 'md',
  showWordmark = true,
  src: srcProp,
}: LogoProps) {
  const [src, setSrc] = useState(srcProp ?? logoPath);

  return (
    <div className={`logo logo--${size}`}>
      <img
        src={src}
        alt={t('brand')}
        className="logo__image"
        onError={() => setSrc(logoFallbackPath)}
      />
      {showWordmark && <span className="logo__wordmark">{t('brand')}</span>}
    </div>
  );
}
